<template>
  <div class="expandable-panel">
    <div class="box">
      <template>
        <slot name="panel-header" :classes="'box__header'" :expand="expandDiv">
          <div @click.prevent="expandDiv" class="box__header">
            <slot name="panel-title">{{ title }}</slot>
          </div>
        </slot>

        <div ref="panel-content" class="box__content">
          <transition name="expand" @enter="enter" @after-enter="afterEnter" @leave="leave">
            <slot name="panel-content" v-if="isExpanded"></slot>
          </transition>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ExpandablePanel',
  props: {
    title: { type: String },
    expand: { type: Boolean },
  },
  data() {
    return {
      toggling: false,
      isExpanded: false,
    }
  },
  computed: {
    clickExpand() {
      return this.$attrs.hasOwnProperty.call(this.$attrs, 'clickExpand')
    },
  },
  watch: {
    isExpanded: {
      immediate: true,
      handler(val) {
        if (val && this.clickExpand) {
          window.addEventListener('mouseup', this.closeEvent)
        }
      },
    },
    expand: {
      immediate: true,
      handler(val) {
        if (!this.clickExpand) {
          this.isExpanded = val
        }
      },
    },
  },
  methods: {
    onExpandDiv() {
      /**
       * handler for slot only works if clickExpand is set
       */
      if (this.clickExpand) {
        this.expandDiv()
      }
    },
    expandDiv() {
      /** This Toggle Method handles the classes note the setTimeout must be set to match the animation time */
      if (this.clickExpand) {
        this.isExpanded = !this.isExpanded
      }
    },
    removeEvent() {
      window.removeEventListener('mouseup', this.closeEvent)
    },
    closeEvent(e) {
      if (this.$el.contains(e.target) || this.$el.contains(e.target.parentNode)) {
        return
      }
      this.isExpanded = false
      this.removeEvent()
    },
    enter(element) {
      const currentElement = element
      const width = getComputedStyle(currentElement).width

      currentElement.style.width = width
      currentElement.style.position = 'absolute'
      currentElement.style.visibility = 'hidden'
      currentElement.style.height = 'auto'

      const height = getComputedStyle(currentElement).height

      currentElement.style.width = null
      currentElement.style.position = null
      currentElement.style.visibility = null
      currentElement.style.height = 0

      // Force repaint to make sure the
      // animation is triggered correctly.
      void getComputedStyle(currentElement).height

      // Trigger the animation.
      // We use `setTimeout` because we need
      // to make sure the browser has finished
      // painting after setting the `height`
      // to `0` in the line above.
      setTimeout(() => {
        currentElement.style.height = height
      })
    },
    afterEnter(element) {
      const currentElement = element
      currentElement.style.height = 'auto'
    },
    leave(element) {
      const currentElement = element
      const height = getComputedStyle(currentElement).height

      currentElement.style.height = height

      // Force repaint to make sure the
      // animation is triggered correctly.
      void getComputedStyle(currentElement).height

      setTimeout(() => {
        currentElement.style.height = 0
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.box {
  border-radius: 0.5rem;
  border: none;
}
.box__header {
  cursor: pointer;
  // border: 1px solid $silver;
}
.box__content {
}

* {
  will-change: height;
  transform: translateZ(0);
  backface-visibility: hidden;
  perspective: 1000px;
}

.expand-enter-active,
.expand-leave-active {
  transition: height 0.5s ease-in-out;
  overflow: hidden;
}

.expand-enter,
.expand-leave-to {
  height: 0;
}
</style>
